import { jsx } from 'react/jsx-runtime';
import { clsx } from '@flex-design-system/ve-presets';
import { forwardRef } from 'react';
import { segmentedControlIndicator } from './indicator.vanilla.mjs';

const SegmentedControlIndicator = forwardRef(
  ({
    className: classNameFromProps,
    dir = "ltr",
    prefersReducedMotion,
    ...props
  }, forwardedRef) => {
    const className = clsx(
      segmentedControlIndicator({ prefersReducedMotion }),
      classNameFromProps
    );
    return /* @__PURE__ */ jsx(
      "div",
      {
        "aria-hidden": true,
        "data-scope": "segmented-control",
        "data-part": "indicator",
        "data-orientation": "horizontal",
        dir,
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
SegmentedControlIndicator.displayName = "SegmentedControl.Indicator";

export { SegmentedControlIndicator };
//# sourceMappingURL=Indicator.mjs.map
